import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "@/hooks";
import { updateTemplate } from "@/features/admin/templates/slice";
import { Editor } from "@/components";
import routes from "@/constants/routes";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useFetchTemplateByIdQuery } from "@/features/templates/templatesApi";
import PageLoading from "@/components/page-loading/PageLoading";
import "./styles.scss";

const TemplateEditor = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { templateId } = useParams<{ templateId: string }>();

  const template = useFetchTemplateByIdQuery(templateId || skipToken, {
    skip: !templateId,
  });

  const saveTemplate = (data: string) => {
    if (!template?.data) return;
    dispatch(updateTemplate({ ...template.data, data }));
  };

  const handleClose = () => {
    navigate(routes.templates.main);
  };

  if (template.isLoading) {
    return <PageLoading />;
  }

  if (!template?.data) {
    return <h2>Plantilla no econtrada, elige otra plantilla</h2>;
  }

  return <Editor title={template.data.title} data={template.data?.data ?? ""} onSave={saveTemplate} onClose={handleClose} template={template.data} />;
};

export default TemplateEditor;
